import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { IPanelPageProps } from '~/lib/PanelApp';
import RegistrationForm from './RegistrationForm';

import ViewInMpanel from '~/components/ViewInMpanel';
import PreLoginPanel from '~/components/PreLoginPanel';
import ConfirmEmail from './ConfirmEmail';
import { WithSearch } from '~/lib/helper/LocationHelper';

export default class RegistrationPage extends React.Component<IPanelPageProps> {
    render() {
        return (
            <div className="registrationPage">
                <ViewInMpanel unauthenticated={true} section="register" />
                <PreLoginPanel>
                    <Routes>
                        <Route path="/" element={<RegistrationForm />} />
                        <Route
                            path="/confirm-email"
                            element={
                                <WithSearch>
                                    {(query) => {
                                        const id = query.get('id');
                                        if (!id) {
                                            return <Navigate to="/" />;
                                        }
                                        return <ConfirmEmail id={id} />;
                                    }}
                                </WithSearch>
                            }
                        />
                    </Routes>
                </PreLoginPanel>
            </div>
        );
    }
}
